import VinAlternativesModal from './VinAlternativesModal'
import vinAlternativesModalContainer from './vinAlternativesModalContainer'

export default vinAlternativesModalContainer(VinAlternativesModal)
